import * as React from 'react';
// import 'react-resizable/css/styles.css';
import { ResizableBox, ResizableBoxProps } from 'react-resizable';
import styles from './resizable.module.css';
import clsx from 'clsx';

export const Resizable: React.FunctionComponent<ResizableBoxProps> = ({ children, className, ...props }) => {
    return (
        <ResizableBox {...props} className={clsx(className, styles['container'])}>
            {children}
        </ResizableBox>
    );
};
